import { Reveal } from "./Reveal";
import { Motif } from "./Motifs";

export const PageHeader = ({ eyebrow, title, description, testId, motif = "flower" }) => (
  <section data-testid={testId} className="relative overflow-hidden pb-14 pt-36 sm:pb-20 sm:pt-44">
    <Motif
      type={motif}
      className="pointer-events-none absolute -right-8 top-24 w-56 select-none text-[#C04B58] opacity-[0.07] sm:w-72"
    />
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <div className="flex items-center gap-4">
          <span className="h-px w-12 bg-[#9A3542]" />
          <p className="eyebrow">{eyebrow}</p>
        </div>
        <h1 className="font-display mt-6 max-w-3xl text-4xl font-semibold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        {description && <p className="mt-6 max-w-2xl text-base leading-relaxed text-zinc-400">{description}</p>}
      </Reveal>
    </div>
  </section>
);
